import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.33331 7.33569V3.33569H8.66665V7.33569H12.6666V8.66903H8.66665V12.669H7.33331V8.66903H3.33331V7.33569H7.33331Z" }));
export default SvgPlus;
